<app-base-modal [isOpen]="isOpen" [withOverlay]="false" (close)="onClose()">
  <h1 header>Address select</h1>

  <div *ngIf="isContactsExist; else placeholder" class="select-contact-modal">
    <div class="select-contact-modal__search-wrapper">
      <div class="select-contact-modal__search-input-wrapper">
        <img src="assets/img/search.svg" alt="" class="select-contact-modal__search-icon" />

        <input
          type="search"
          placeholder="Enter search criteria"
          [(ngModel)]="contactsSearchParams.searchString"
          class="form-input select-contact-modal__search-input"
        />
      </div>

      <button class="btn_primary btn_sm select-contact-modal__search-btn" (click)="getContacts()">
        Search
      </button>
    </div>

    <div class="contact-table">
      <div class="contact-table__head">
        <div class="contact-table__head-item">Fax Number</div>
        <div class="contact-table__head-item">Name</div>
        <div class="contact-table__head-item">Email</div>
      </div>

      <div class="contact-table__body">
        <div *ngFor="let contact of contacts" class="contact-table__body-row" (click)="onSelect(contact)">
          <div class="contact-table__body-item">{{ contact.faxNumber }}</div>
          <div class="contact-table__body-item">{{ contact.name }}</div>
          <div class="contact-table__body-item">{{ contact.email }}</div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #placeholder>
    <div class="select-contact-modal__placeholder">
      <p>Phone book is empty</p>
    </div>
  </ng-template>
</app-base-modal>
